export enum QueueTrackingKeyEnum {
  ProductRecomputeAll = 'product.recomputeAll',
  PayrollProcess = 'payroll.process',
}
